import React, { Component } from "react";
import { Link } from 'react-router-dom';
import WithConsumer from '../../context/WithConsumer';

export default class PageNavigation extends Component {
	
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <div data-id={block.id} className={'c-page__block c-page__block--load-effect c-page__block--space-' + block.space_after + ' c-page__block--' + block.rule_after}>
			    
			    	<div className="l-content l-content--fixed-width">
			    		
			    		<div className="l-grid">
			    		
			    			<div className="l-grid__col">
			    				
	    						<div className="c-filters">
	    						
	    							{block.items &&
		    							<ul className="c-filters__list">
											{block.items.map((item,i) => 
												{
													return (
														<li className="c-filters__list__item" key={i}>
															<Link to={item.url} className="c-filters__list__link">{item.title}</Link>
														</li>
													)
												}
											)}
										</ul>
									}
									
								</div>
								
							</div>
			    			
			    		</div>
			    		
			    	</div>
			    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
